<!-- The same scrim the app's bottom sheets lay over the page, so the open panel reads
	as a sheet. Kept mounted so it fades both ways; inert while the panel is shut. -->
<div
	class="fixed inset-0 z-1000 bg-[rgb(0_0_0/50%)] transition-opacity duration-200"
	data-cy="wallet-buying-power-overlay"
	aria-hidden="true"
	[class.opacity-0]="!expanded()"
	[class.pointer-events-none]="!expanded()"
	(click)="close()"></div>

<div class="absolute inset-x-0 bottom-0 z-1001 rounded-t-xl border-t border-stroke-050 bg-gray-000">
	<!-- The one control: collapsed it is the قدرت خرید strip, open it is the handle
		that closes the panel again — the two states the handoff draws.

		Its height is pinned rather than left to its content: the two states hold
		different things, and letting them size themselves snapped the whole footer by
		a few pixels on every toggle while the panel below was still animating. -->
	<button
		type="button"
		class="relative flex h-8 w-full items-center justify-between gap-2 px-4"
		data-cy="wallet-buying-power-bar"
		[attr.aria-label]="toggleLabel()"
		[attr.aria-expanded]="expanded()"
		[attr.aria-controls]="panelId"
		(click)="onToggle()">
		<!-- Centred on the bar rather than laid out between the label and the figure:
			in the flow `justify-between` puts it wherever those two leave it, which is
			only the middle when they happen to be the same width — and it drifts as the
			figure grows. Out of flow it is pinned to the bar's centre in both states. -->
		<span class="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden="true">
			<ui-icon width="30" height="30" class="text-gray-300" [iconName]="expanded() ? 'bs-down' : 'bs-up'" />
		</span>

		<!-- Faded rather than unmounted. Dropping it on the tap left the strip empty for
			the length of the panel's animation, which read as the bar hesitating before
			anything moved; opacity is composited, so it rides along with the panel. -->
		<span
			class="flex w-full items-center justify-between gap-2 transition-opacity duration-200"
			[class.opacity-0]="expanded()"
			[attr.aria-hidden]="expanded()">
			<span class="text-xs font-medium text-gray-900">قدرت خرید</span>
			<span class="flex items-center gap-1 text-3.25 font-medium">
				@if (amountsHidden()) {
					<span class="tracking-widest text-gray-900" data-cy="wallet-buying-power-bar-value">
						{{ maskedValue }}
					</span>
				} @else {
					<ui-number
						format="1.0-0"
						dir="ltr"
						class="tabular-nums text-gray-900"
						data-cy="wallet-buying-power-bar-value"
						[value]="buyingPower()" />
				}
				<span class="text-gray-500">ریالءء</span>
			</span>
		</span>
	</button>

	<!-- Grown rather than revealed: the 0fr→1fr row makes the panel push the strip
		up from where it sits, instead of arriving over the page from below. It stays
		in the DOM either way, so `aria-controls` above always names something real. -->
	<div
		class="grid transition-[grid-template-rows] duration-200 ease-out"
		[style.grid-template-rows]="expanded() ? '1fr' : '0fr'">
		<div class="overflow-hidden" [id]="panelId" [attr.aria-hidden]="!expanded()">
			<!-- Label first, value second: that is the RTL reading order, so each row's
				name sits on the visual right and its figure on the left. -->
			<dl class="flex flex-col" data-cy="wallet-buying-power-rows">
				@for (row of rows(); track row.dataCy; let first = $first) {
					<div
						class="mx-4 flex items-center justify-between gap-2 py-2"
						[class.border-t]="!first"
						[class.border-stroke-050]="!first">
						<dt class="text-xs font-medium text-gray-900">{{ row.label }}</dt>
						<dd
							class="flex items-center gap-1 text-3.25 font-medium"
							[class.text-yellow-600]="row.emphasised"
							[class.text-gray-900]="!row.emphasised">
							@if (amountsHidden()) {
								<span class="tracking-widest" [attr.data-cy]="row.dataCy">{{ maskedValue }}</span>
							} @else {
								<ui-number
									format="1.0-0"
									dir="ltr"
									class="tabular-nums"
									[attr.data-cy]="row.dataCy"
									[value]="row.value" />
							}
							<span [class.text-gray-500]="!row.emphasised">ریالءء</span>
						</dd>
					</div>
				}
			</dl>

			<div class="flex w-full items-center px-4 pt-1.5 pb-2.5">
				<ui-button
					variant="green"
					model="outline"
					size="md"
					class="w-full"
					extraButtonClasses="h-9 w-full"
					data-cy="wallet-buying-power-deposit"
					[disabled]="!expanded()"
					(clicked)="onDepositRequested()">
					واریز وجه
					<ui-icon rightIcon width="20" height="20" iconName="plus" />
				</ui-button>
			</div>
		</div>
	</div>
</div>
